import { CoreDataDictionaryViewsName } from './name';
import { DataDictionaryView } from '@types';
import { patchDataDictionaryView } from '@api';
import { updateCoreDataDictionaryViewsSyncSlice } from './update';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const patchCoreDataDictionaryViewsAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => {
				const { viewId, viewName, ...rest } = request;
				const update: Partial<DataDictionaryView> = {
					id: viewId,
					...rest
				};

				if (viewName) {
					update.name = viewName;
				}

				return updateCoreDataDictionaryViewsSyncSlice.syncActionCreator(update);
			}
		]
	},
	name: CoreDataDictionaryViewsName,
	receive: false,
	request: true,
	requestHandler: patchDataDictionaryView,
	yieldType: SagaYieldType.Every
});
